 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		70: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay-mobile~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~orange-lens","13":"bath-renovation~consumer-card-messaging","14":"buybox~quick-view","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","19":"StoreLayout","20":"add-to-list-drawer","21":"aisle-bay","22":"augmented-reality","23":"bath-renovation","24":"breadcrumbs","25":"browse-and-search","26":"browse-and-search-mobile","27":"buybox","28":"calculator-pipcalculator","29":"collections","30":"collections-mobile","31":"common","32":"compare","33":"consumer-card-messaging","34":"customer-image-overlay","35":"drawer","36":"emt-generated-content","37":"emt-links","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"message-types","50":"orange-lens","51":"order-sample","52":"order-sample-drawer","53":"overlay","54":"paint-reorder","55":"paint-reorder-mobile","56":"pep","57":"pep-mobile","58":"product","59":"product-mobile","60":"product-overview","61":"promotion-products-lazy","62":"question","63":"questions-and-answers","64":"quick-view","65":"ratings-and-reviews","66":"ratings-and-reviews-desktop","67":"ratings-and-reviews-mobile","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"3458a3eb330cb9b93f88","1":"a91a86bad6b51bc1a45f","2":"aed31282d0f5f44fc868","3":"a18da7efe27368e38bc9","4":"9d77b6873ddb3c507c81","5":"536371a79e1a0278e004","6":"535d28389cba8be9b5af","7":"c232b545c3948331d213","8":"d48b8378988b799b419c","9":"20a56342f2e456ea7b48","10":"17eb33e465c23bf0c920","11":"df9b860709b599e20f4a","12":"28d369d4cee4f940a4d7","13":"df3bf2c5b4bf834f4859","14":"6f253c23dab028f0ab46","15":"0654a7334016b247ab2e","16":"c2cd3f3dd068326f6bd3","17":"548df39cf5d67b10fe00","18":"ee147947353e5d56bd81","19":"5190745ba5b335dd96ec","20":"a0bce520b0173e7d63d5","21":"73305981cfb447fdc81e","22":"9d196cb13df3240a1299","23":"93b8d51439ae77e936f0","24":"131ac0ca78678597b757","25":"3258a44e4666d8543439","26":"a37f52a8465e5b313840","27":"4a82733c86f2a4fe0448","28":"3f3b756a2e740f498544","29":"bfdc5c1ebdb94b393548","30":"968f7e1f04def5cc3280","31":"8e5f7f322d088de683ea","32":"85b0855a52aaf571bd55","33":"00582333f84af34243a4","34":"c5a4242ab5aeffbdc0cf","35":"369fe471de3dc6aa3510","36":"49cbc85c1584acc81085","37":"81ceb0ee4bb7b572a2eb","38":"d908485c22258336efa0","39":"b15444d297d36042fc10","40":"ec8825588e5c82558c94","42":"ece00f50034cb45f5767","43":"118b4820325ed2752a39","44":"d734532eb4051830bc01","45":"44f7e0f46b40a069e24b","46":"afece174f40bc95fedc9","47":"5e73551145c2d5e61168","48":"f2679fd22f698f9ce82f","49":"51443ff9f39ca0f5ca46","50":"5f328c328863e32899f6","51":"f721f7b602768cfe8cf4","52":"27f181786e4d8a249d4e","53":"27f993412d53b7e31cc3","54":"7cd8ec4cdd571558aadd","55":"58c870e3c0146988a155","56":"f27ac8060152ad56d1d0","57":"50e8b234ef003b72db3f","58":"da9aa9bcb2ff0fbeed8e","59":"a54c38979ae2d0b0a4b0","60":"151f45105de12b0b2699","61":"d51d6fa5885717ab8e5c","62":"40ae255559f8975c5f91","63":"e4989ec9f86a8a473618","64":"8605e99684207a67e27e","65":"68e50c97c2c11dcf1ee2","66":"99f4fab06f7a9b32d051","67":"3d80a5ce1b59bd2c9472","68":"df0fb66ab0d35c86ebc4","69":"077b75b6b4ae0a276550","71":"0570fbca4341f9b0b927","72":"4235ea531870c21bb443","73":"554c121b51362d0b456a","74":"b89a595088c8957e5a26","75":"2bb3ecdadc85a95f977f","76":"c8051ec8d779b4f1f728","77":"0d6d22104900965a7d55","78":"1f412567eb08816e5e55","79":"8df7522e6cd7c652f87d","81":"f776e2d53c5d593ad5de","82":"c011b80d745832c869ca","83":"b6686085451b61f9c170"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"14":1,"15":1,"16":1,"21":1,"25":1,"26":1,"27":1,"29":1,"30":1,"32":1,"33":1,"34":1,"35":1,"36":1,"38":1,"39":1,"43":1,"46":1,"47":1,"48":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"63":1,"64":1,"65":1,"67":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"82":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay-mobile~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~orange-lens","13":"bath-renovation~consumer-card-messaging","14":"buybox~quick-view","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","19":"StoreLayout","20":"add-to-list-drawer","21":"aisle-bay","22":"augmented-reality","23":"bath-renovation","24":"breadcrumbs","25":"browse-and-search","26":"browse-and-search-mobile","27":"buybox","28":"calculator-pipcalculator","29":"collections","30":"collections-mobile","31":"common","32":"compare","33":"consumer-card-messaging","34":"customer-image-overlay","35":"drawer","36":"emt-generated-content","37":"emt-links","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"message-types","50":"orange-lens","51":"order-sample","52":"order-sample-drawer","53":"overlay","54":"paint-reorder","55":"paint-reorder-mobile","56":"pep","57":"pep-mobile","58":"product","59":"product-mobile","60":"product-overview","61":"promotion-products-lazy","62":"question","63":"questions-and-answers","64":"quick-view","65":"ratings-and-reviews","66":"ratings-and-reviews-desktop","67":"ratings-and-reviews-mobile","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"46d0ac7da3db8adb1367","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"7647b1510da5618b37af","5":"83588448fb37280fe4ec","6":"89d9163eeb30e835d559","7":"1955189c596e6d9ade5e","8":"d6905e41bc7aa3f68e43","9":"0ef658ad0521bc70e648","10":"b31ab9f510c449fb1965","11":"7c2eed0c18c49e42c517","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"95a5994acce6e02a6b07","15":"19391484b2828e6b673c","16":"2a09750166a70e474555","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"d94b956aa532c1a50c65","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"da9375dd4156742b8a00","26":"5145233d47250459737a","27":"3525a296340088d9c82f","28":"31d6cfe0d16ae931b73c","29":"f5d04340c0fb3cf79b54","30":"8582f4896bb0e0c70020","31":"31d6cfe0d16ae931b73c","32":"ffe192ad5912a5ec682f","33":"c07ce9ab259c3f695942","34":"c466036523aec2558c34","35":"fc73174b407ad863c497","36":"b49004ddac99adec2224","37":"31d6cfe0d16ae931b73c","38":"88e24c7aafcf93ae6cc6","39":"1a5562a08d12f7682989","40":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"ceebf150d8a696023a14","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"e07956ac4ef9facbea2e","47":"80e7638adbdaec3de4f3","48":"94643b3e85240c6db752","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"b5080a0ec3bf23c04b62","54":"586eb667db85c93177b2","55":"2b3bd255244dc7f9a5a1","56":"0c44e1b3459216ba37d8","57":"7af2b4800650c91112a6","58":"3c3e5fb3812bcda08e04","59":"b6cb16928e4521401eb5","60":"be155bb5d11dacdc4bb8","61":"c7e4a3cb02089bb4d052","62":"31d6cfe0d16ae931b73c","63":"d70c859b20e57c1599c5","64":"3fb67ef60d9f4cf19fb8","65":"adb0fe17b71f17fdebd9","66":"31d6cfe0d16ae931b73c","67":"2ade42f7647d0b013747","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"453dfc2640779a848cc6","74":"31d6cfe0d16ae931b73c","75":"6c6bdd949ddd0752832b","76":"922dbc8ed510a58afe20","77":"e518e335254638969e62","78":"fbae370640798a57513a","79":"05ba11d0a20efb76fea5","81":"31d6cfe0d16ae931b73c","82":"5512b06edf556d72360f","83":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
